<script lang="ts" setup="">
import WidgetForm from '~/features/bitrix/WidgetForm.vue'
import Modal from '~/components/ui/modals/Modal.vue'
import useMainStore from "~/shared/store";

const mainStore = useMainStore()

</script>

<template>
  <Modal
    class="widget-modal"
    :modal-is-open="mainStore.isBitrixWidgetModal"
    modal-title="Нужна консультация? Оставьте заявку!"
    @close-modal="mainStore.setBitrixModalState(false)"
  >
    <WidgetForm
      @send-form="mainStore.setBitrixModalState(false)"
    />
  </Modal>
</template>

<style lang="scss" scoped>
.widget-modal {
  z-index: 10000;
  :deep(.modal-content) {
    max-width: 636px;
    width: 100%;
    @include md-breakpoint {
      max-width: none;
    }
  }
}
</style>
